import { supabase } from "./supabase";

export type DeploymentMode = "live" | "maintenance";
export type DeploymentState = { mode: DeploymentMode; opportunitiesEnabled: boolean; updatedAt: string | null };

type DeploymentRow = { mode?: unknown; opportunities_enabled?: unknown; updated_at?: unknown };

function normalizeDeploymentRow(row: DeploymentRow | undefined): DeploymentState {
  if (!row || (row.mode !== "live" && row.mode !== "maintenance")) {
    throw new Error("The global deployment state is unavailable.");
  }
  return {
    mode: row.mode,
    opportunitiesEnabled: row.opportunities_enabled === true,
    updatedAt: typeof row.updated_at === "string" ? row.updated_at : null,
  };
}

export async function readGlobalDeploymentState(): Promise<DeploymentState> {
  const { data, error } = await supabase
    .from("site_deployment")
    .select("mode,opportunities_enabled,updated_at")
    .eq("id", "global")
    .single();
  if (error) throw error;
  return normalizeDeploymentRow(data as DeploymentRow);
}

export async function writeGlobalDeploymentState(mode: DeploymentMode): Promise<DeploymentState> {
  const { data, error } = await supabase
    .from("site_deployment")
    .update({ mode })
    .eq("id", "global")
    .select("mode,opportunities_enabled,updated_at")
    .single();
  if (error) throw error;
  return normalizeDeploymentRow(data as DeploymentRow);
}

export async function writeOpportunitiesEnabled(enabled: boolean): Promise<DeploymentState> {
  const { data, error } = await supabase
    .from("site_deployment")
    .update({ opportunities_enabled: enabled })
    .eq("id", "global")
    .select("mode,opportunities_enabled,updated_at")
    .single();
  if (error) throw error;
  return normalizeDeploymentRow(data as DeploymentRow);
}
